import {UniteQuantite} from 'api-types/ffconnect';

interface GetAddArticlePayloadWithColisFallbackArgs {
  commandeEnColis: boolean;
  quantiteColisEntier: number | null | undefined;
  minimumCommande: number;
  multipleCommande: number;
}

interface AddArticlePayload {
  quantite: number;
  commande_en: UniteQuantite;
}

interface IsCommandableEnColisArgs {
  quantiteColisEntier?: number | null;
  multipleCommande?: number | null;
}

export const isCommandableEnColis = (
  args: IsCommandableEnColisArgs,
): args is IsCommandableEnColisArgs & {quantiteColisEntier: number} => {
  return (
    typeof args.quantiteColisEntier === 'number' &&
    args.quantiteColisEntier > 0 &&
    args.quantiteColisEntier !== 999999999 &&
    args.quantiteColisEntier !== args.multipleCommande
  );
};

export const getAddArticlePayloadWithColisFallback = ({
  commandeEnColis,
  quantiteColisEntier,
  minimumCommande,
  multipleCommande,
}: GetAddArticlePayloadWithColisFallbackArgs): AddArticlePayload => {
  const quantiteUnitaire = Math.max(minimumCommande, multipleCommande);
  const colisArgs = {quantiteColisEntier, multipleCommande};
  const peutCommanderEnColis =
    commandeEnColis && isCommandableEnColis(colisArgs);

  return {
    quantite: peutCommanderEnColis
      ? colisArgs.quantiteColisEntier
      : quantiteUnitaire,
    commande_en: peutCommanderEnColis ? 'colis' : 'unitaire',
  };
};
